module.exports = __webpack_public_path__ + "static/media/veterans.beecf736.JPG";